module.exports = __webpack_public_path__ + "src/img/yul.e8c93fab.svg";